import { Heading, Link, SimpleGrid, Text } from "@chakra-ui/react";
import LandingContent from "../../components/landing-content";
import { siteConfig } from "../../configuration/config";

export const cmsBaseLink = "https://cms.aidia.dk/wp-json/wp/v2";

export const getWpCategories = (post: any) => {
  return post._embedded?.["wp:term"]?.[0]?.map((category: any) => category.name);
};

export async function fetchWordPressHelpPosts() {
  // if (process.env.NODE_ENV === "development") {
  //   return [];
  // }

  const res = await fetch(`${cmsBaseLink}/posts?_embed&per_page=100`);
  const posts = await res.json();

  return posts
    .filter((post: any) => getWpCategories(post).includes("help"))
    .map((post: any) => ({
      params: {
        id: post.slug,
        title: post.title.rendered,
      },
      date: post.date,
      isWordPress: true,
    }));
}

interface PostMeta {
  params: {
    id: string;
    title: string;
  };
  date: string;
  isWordPress?: boolean;
}

export default function Help({ helpPostsAsc }: { helpPostsAsc: PostMeta[] }) {
  return (
    <LandingContent>
      <Heading mb={3} size="md" as="h1" w="full">
        Help Center
      </Heading>
      <Text mb={10} as="h2" fontSize="lg">
        Find answers and guides for using Talkio AI. Browse through our help articles to learn about
        features, best practices, and common questions. If you cannot find what you are looking for,
        please contact us at{" "}
        <Link textDecoration="underline" href="mailto:support@talkio.ai">
          support@talkio.ai
        </Link>
      </Text>
      <SimpleGrid columns={1} spacing={2}>
        {helpPostsAsc.map((post, i) => (
          <Link
            key={i}
            href={`/help/${post.params.id}`}
            py={3}
            px={5}
            border="1px solid #ddd"
            display="block"
            bg="#fbfbfb"
            _hover={{ textDecoration: "none", bg: "brand.gray.200" }}
          >
            {post.params.title}
          </Link>
        ))}
      </SimpleGrid>
    </LandingContent>
  );
}

export async function getStaticProps() {
  const helpPosts = siteConfig.isDefault ? await fetchWordPressHelpPosts() : [];
  const helpPostsAsc = [...helpPosts].sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
  );
  return {
    props: {
      helpPostsAsc,
    },
    revalidate: 60,
  };
}
